/* eslint-disable no-useless-escape */
/* eslint-disable no-empty-character-class */

import mixpanel from 'mixpanel-browser'

const isDevelopment = process.env.NODE_ENV === 'development'
const mixpanelInstance = mixpanel
export const MIXPANEL_EXP_CONFIG_KEY = 'mp_exp_config'

function getQueryParam(url, param) {
  // Expects a raw URL
  param = param.replace(/[[]/, '\[').replace(/[]]/, '\]')
  var regexS = '[\?&]' + param + '=([^&#]*)',
    regex = new RegExp( regexS ),
    results = regex.exec(url)
  if (results === null || (results && typeof(results[1]) !== 'string' && results[1].length)) {
    return ''
  } else {
    return decodeURIComponent(results[1]).replace(/\W/gi, ' ')
  }
}

function campaignParams() {
  var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' ')
    , kw = ''
    , params = {}
    , first_params = {}
  var index
  for (index = 0; index < campaign_keywords.length; ++index) {
    kw = getQueryParam(document.URL, campaign_keywords[index])
    if (kw.length) {
      params[campaign_keywords[index] + ' [last touch]'] = kw
    }
  }
  for (index = 0; index < campaign_keywords.length; ++index) {
    kw = getQueryParam(document.URL, campaign_keywords[index])
    if (kw.length) {
      first_params[campaign_keywords[index] + ' [first touch]'] = kw
    }
  }

  mixpanelInstance.people.set(params)
  mixpanelInstance.people.set_once(first_params)
  mixpanelInstance.register(params)
}

function configMixpanelCookieExpiration(expirationInDays = 30) {
  mixpanelInstance.set_config({
    cookie_expiration: expirationInDays
  })

  const now = new Date()
  const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000
  const expirationTime = now.getTime() + expirationInDays * ONE_DAY_IN_MILLISECONDS
  const expirationData = {
    expiration: expirationTime,
    expirationDate: new Date(expirationTime).toISOString()
  }

  localStorage.setItem(MIXPANEL_EXP_CONFIG_KEY, JSON.stringify(expirationData))
}

function configCookie() {
  const parsedConfig = JSON.parse(localStorage.getItem(MIXPANEL_EXP_CONFIG_KEY))
  const now = new Date()
  const nowTime = now.getTime()
  const isNowAfterExpiration = nowTime > parsedConfig?.expiration

  // Se não existir uma configuração de expiração ou se a data de expiração for menor que a data atual,
  // cria uma nova configuração com 30 dias de expiração
  if (!parsedConfig || isNowAfterExpiration) {
    configMixpanelCookieExpiration()
    return
  }

  // Se a data de expiração for maior que a data atual, cria uma nova configuração com o tempo restante de expiração
  if (nowTime < parsedConfig.expiration) {
    const timeLeft = parsedConfig.expiration - nowTime
    const timeLeftInDays = timeLeft / (24 * 60 * 60 * 1000)
    mixpanelInstance.set_config({
      cookie_expiration: timeLeftInDays
    })

    return
  }
}

const getUtmProperties = () => {
  return  {
    utm_source: mixpanel.get_property('utm_source'),
    utm_medium: mixpanel.get_property('utm_medium'),
    utm_campaign: mixpanel.get_property('utm_campaign'),
    utm_term: mixpanel.get_property('utm_term'),
    utm_content: mixpanel.get_property('utm_content'),
  }
}


function initializeMixPanel(appToken) {
  mixpanelInstance.init(appToken, {
    debug: isDevelopment,
    ignore_dnt: true,
  })
  campaignParams()
  configCookie()
}

export {
  mixpanelInstance,
  initializeMixPanel,
  getUtmProperties,
  configMixpanelCookieExpiration
}
